import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Article} from '../models/article.models';
import {ArticleInventorySum} from '../../workflow/models/inventory.models';
import {RightService} from '../../../common/right-service/right.service';
import {LoadingWrapper} from '../../../common/loading/loading-wrapper';
import {ArticleWizardForm} from '../../../react/article/wizard/article-wizard.models';
import {ArticleWizardAxiosService} from '../../../react/article/wizard/article-wizard-axios.service';
import {from, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'article-box',
    templateUrl: './article-box.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleBoxComponent implements OnInit {
  @Input() withTitle = true;
  @Input() targetWindow = '_self';
  @Input() right = true;
  @Input() workflowId?: number;
  @Input() article: Article;
  @Input() inventory: ArticleInventorySum;
  @Output() reloadInventory: EventEmitter<number> = new EventEmitter<number>();
  workflowUrl?: string;
  wizardForm: LoadingWrapper<ArticleWizardForm | null>;

  constructor(private rightService: RightService) {
  }

  ngOnInit(): void {
    this.workflowUrl = '';
    if (this.workflowId) {
      this.workflowUrl = '?workflow_id=' + this.workflowId?.toString(10);
    }

    this.wizardForm = this.rightService.has('article.wizard_create') ?
      new LoadingWrapper<ArticleWizardForm | null>(from(ArticleWizardAxiosService.get(this.article.oa_nr))
        .pipe(
          map(p => p),
          catchError(error => {
            return error instanceof HttpErrorResponse && error.status === 404 ? of(null) : of(error);
          }))) :
      new LoadingWrapper<ArticleWizardForm | null>(of(null));
  }
}
